import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import classNames           from 'classnames';
import FaCheck              from 'react-icons/lib/fa/check';
import { browserHistory }   from 'react-router';

let Quote = require('../Managers/Quote');

class HeaderSteps extends Component {
    moveTo(step) {
        browserHistory.push(step.url);
    }

    render() {
        let stepObject = [];

        let productId = Quote.getByPath('BaseIndividualApplication.product.productId');
        let applicationType = Quote.getByPath('BaseIndividualApplication.applicationType');
        let referenceType = Quote.getByPath('BaseIndividualApplication.referenceType');
        let studentOnly = null;
        if (!window.uornorb(Quote.getByPath('BaseIndividualApplication.studentOnlyApplication'))) {
            studentOnly = Quote.getByPath('BaseIndividualApplication.studentOnlyApplication');
        }
        if (productId === 20 || (productId === 11 && studentOnly === true) || (productId === 24 && referenceType === 1)) {
            // Insight skips letting and financial referee steps
            stepObject.push(
                {
                    number: 1,
                    text: 'Declaration',
                    url: "/application/declaration",
                },
                {
                    number: 2,
                    text: 'Your details',
                    url: "/application/your-details",
                },
                {
                    number: 3,
                    text: 'Additional details',
                    url: "/application/additional-details",
                },
                {
                    number: 4,
                    text: 'Summary',
                    url: "/application/summary",
                },
            );
        } else if (studentOnly === true && applicationType !== 2) {
            // Student-only AND NOT Guarantor skip financial referee step
            stepObject.push(
                {
                    number: 1,
                    text: 'Declaration',
                    url: "/application/declaration",
                },
                {
                    number: 2,
                    text: 'Your details',
                    url: "/application/your-details",
                },
                {
                    number: 3,
                    text: 'Your landlord',
                    url: "/application/your-landlord",
                },
                {
                    number: 4,
                    text: 'Additional details',
                    url: "/application/additional-details",
                },
                {
                    number: 5,
                    text: 'Summary',
                    url: "/application/summary",
                },
            );
        } else if (productId === 11 || applicationType === 2) {
            // Xpress or Guarantor - both skip letting referee step
            stepObject.push(
                {
                    number: 1,
                    text: 'Declaration',
                    url: "/application/declaration",
                },
                {
                    number: 2,
                    text: 'Your details',
                    url: "/application/your-details",
                },
                {
                    number: 3,
                    text: 'Your finances',
                    url: "/application/your-finances",
                },
                {
                    number: 4,
                    text: 'Additional details',
                    url: "/application/additional-details",
                },
                {
                    number: 5,
                    text: 'Summary',
                    url: "/application/summary",
                },
            );
        } else {
            // Otherwise we expose all steps
            stepObject.push(
                {
                    number: 1,
                    text: 'Declaration',
                    url: "/application/declaration",
                },
                {
                    number: 2,
                    text: 'Your details',
                    url: "/application/your-details",
                },
                {
                    number: 3,
                    text: 'Your landlord',
                    url: "/application/your-landlord",
                },
                {
                    number: 4,
                    text: 'Your finances',
                    url: "/application/your-finances",
                },
                {
                    number: 5,
                    text: 'Additional details',
                    url: "/application/additional-details",
                },
                {
                    number: 6,
                    text: 'Summary',
                    url: "/application/summary",
                },
            );
        }

        let stepWidth = 100 / stepObject.length;
        let stepStyle = { width: stepWidth + '%' };

        let stepContainerClasses = classNames({
            'steps': true,
            'light-journey': Quote.getByPath('BaseIndividualApplication.product.productId') === 20 || (Quote.getByPath('BaseIndividualApplication.product.productId') === 24 && Quote.getByPath('BaseIndividualApplication.referenceType') === 1) ? true : false,
        });

        return (
            <div className="steps-container">
                <div className={stepContainerClasses}>
                    {stepObject.map(function(i) {
                        let stepClasses = classNames({
                            'step': true,
                            'complete': this.props.current > i.number ? true : false,
                            'pointer': this.props.current > i.number ? true : false,
                            'current': window.location.pathname === i.url ? true : false,
                        });

                        return(
                            <div key={i.number} className={stepClasses} style={stepStyle} onClick={this.props.current > i.number ? this.moveTo.bind(this, i) : null}>
                                <div>
                                    <div className="circle">
                                        <FaCheck className="fa-2x" /><span className="number">{i.number}</span>
                                    </div>
                                    <div className="text">{i.text}</div>
                                </div>
                            </div>
                        );
                    }, this)}
                </div>
            </div>
        );
    }
}

HeaderSteps.propTypes = {
    current:    PropTypes.number.isRequired,
    complete:   PropTypes.number,
    moveTo:     PropTypes.func,
};

export default HeaderSteps;


// WEBPACK FOOTER //
// ./src/components/Fragments/HeaderSteps.js